import React from 'react';
import PropTypes from 'prop-types';
import {Tabs} from 'react-toolbox/lib/tabs';

function SunbitTabs(props) {

  const {children, ...restProps} = props;
  return (
    <Tabs {...restProps}>
      {children}
    </Tabs>
  );
}

SunbitTabs.propTypes = {
  children: PropTypes.node,
};


export default SunbitTabs;



// WEBPACK FOOTER //
// ./src/components/common/material/Tabs.js